import { generateErrorCode } from '../utils/ErrorUtils';
import { ExtendedError } from './ExtendedError';
export class AC3BaseError extends ExtendedError {
    constructor(message, cause, errorCodeContextInputs, displayContext) {
        super(message);
        if (cause) {
            this.cause = cause;
            if (cause instanceof Error) {
                this.causeMessage = cause.message;
            }
            else {
                try {
                    this.causeMessage = JSON.stringify(cause);
                }
                catch (_a) {
                    this.causeMessage = "This is NOT the original error cause message: Error encountered when extracting message from the error cause object.";
                }
            }
        }
        if (errorCodeContextInputs) {
            const errorCode = generateErrorCode(errorCodeContextInputs);
            this.errorCodeContext = Object.assign(Object.assign({}, errorCodeContextInputs), { errorCode });
        }
        if (displayContext) {
            this.displayContext = displayContext;
        }
    }
}
//# sourceMappingURL=AC3BaseError.js.map